import { isLoggedIn } from "utils/auth";

export default (store) => {
  return {
    path: "offerio-setup",
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          const offerio = require("./Offerio").default;
          cb(null, offerio);
        },
        "Offerio"
      );
    },
  };
};



// WEBPACK FOOTER //
// ./src/routes/Offerio/index.js